import React from 'react'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import './video.css'
import axios from 'axios';
import { useState } from 'react'
import { Box } from '@mui/system'
import moment from 'moment'
import './Card.css'
import {
  Button
} from "@mui/material";
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { config } from '../App';
import Header from './Header'
import CardView from './Card'
import { useParams } from 'react-router-dom'



const Video = () => {
  const params = useParams();
  const [video, setVideo] = useState({});
  let id = params.id;
  useEffect(() => {
    console.log(id)
    increaseCount();
    performAPICall(id);
    
  }, [id]);

  const increaseCount = async () => {
     const URL = config.endpoint + "/videos/" + String(id) + "/views";
    console.log(URL);
      try {
        const response = await axios.patch(URL);
        console.log(response.data);  
      } catch (error) {  
        if (error.response) {
          if (error.response.status === 400) {
            console.log(error.response.data.message)
          }
        } else {
            console.log("Backend error")
        }
      }
  }

  const like = async () => {
    const URL = config.endpoint + "/videos/" + String(id) + "/votes";
    console.log(URL);
      try {
        const response = await axios.patch(URL, { "vote": "upVote","change": "increase"});
        console.log(response.data);  
      } catch (error) {  
        if (error.response) {
          if (error.response.status === 400) {
            console.log(error.response.data.message)
          }
        } else {
            console.log("Backend error")
        }
      }
  }

  const dislike = async () => {
    const URL = config.endpoint + "/videos/" + String(id) + "/votes";
    console.log(URL);
      try {
        const response = await axios.patch(URL, { "vote": "downVote","change": "increase"});
        console.log(response.data);  
      } catch (error) {  
        if (error.response) {
          if (error.response.status === 400) {
            console.log(error.response.data.message)
          }
        } else {
            console.log("Backend error")
        }
      }
  }

  const performAPICall = async (id) => {
    //console.log("i am called");
    console.log("i am performAPICall");
    const URL = config.endpoint + "/videos/" + String(id);
    console.log(URL);
    try {

      const response = await axios({
        url: URL,
        method: "get",
      });
      console.log(response.data);

      setVideo(response.data);
      increaseCount();
      // return response.data;
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          console.log(error.response.data.message);
        }
      } else {
        console.log("something went wrong")
      }
      return error;
    }
  };
  const hero = "https://www." + `${video.videoLink}`;
  return (
    <div>
      <Header />
      <Box sx={{ px: 12.4, py: 2 }} bgcolor="primary.dark" className="video">
        <iframe src={hero} className="frame" />
        <Box sx={{ py: 4 }} className="detail"  style={{"border-bottom": "0.1rem solid red"}}>
          <Box>

            <Typography gutterBottom variant="h5" component="div" color="text.primary" className="content">
              {video.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">

              {video.contentRating} | {moment(video.releaseDate).fromNow()}

            </Typography>
          </Box>
          <Box className="content">
            <Button variant="outlined" sx={{ mr: 0.5,borderRadius:10 }} startIcon={<ThumbUpIcon />} onClick={like} >Like</Button>
            <Button variant="outlined" sx={{borderRadius:10}} startIcon={<ThumbDownAltIcon />} onClick={dislike} >Dislike</Button>
          </Box>

        </Box>
      </Box>

      <CardView />

    </div>


  )
}

export default Video